import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../../../Stores/AuthStore";

export function RequireAuth() {
  const auth = useAuthStore();
  const location = useLocation();
  const user = auth.user;

  if (location.hash.startsWith("#login_with_access_token=")) {
    const access_token = location.hash.substring("#login_with_access_token=".length);
    return <Navigate to="/login" state={{ from: location, access_token }} replace />
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Vérifier si l'utilisateur a les rôles admin ou commercial
  const hasAdminRole = user.roles?.includes('ROLE_ADMIN') || user.roles?.includes('ROLE_SUPER_ADMIN') || user.roles?.includes('ROLE_COMMERCIAL');
  
  if (!hasAdminRole) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}